import "./style/App.scss";

import React, { useEffect } from "react";
import { HashRouter as Router, Route, Routes } from "react-router-dom";
import { TCLogin } from "./pages/TCLogin";
import axios from "axios";
import TrimbleProjects from "./pages/TrimbleProjects";
import InfrakitLogin from "./pages/InfrakitLogin";
import InfrakitProjects from "./pages/InfrakitProjects";
import Connections from "./pages/Connections";
import { Folder } from "./pages/Folder";
import RedirectPage from "./pages/RedirectPage";
import { axiosErrorHandler, checkToken } from "./utils/AxiosHandlers";


const REACT_APP_INFRAKIT_IAM_BASE_URL=process.env.REACT_APP_INFRAKIT_IAM_BASE_URL
const REACT_APP_CONNECTOR_BASE_URL=process.env.REACT_APP_CONNECTOR_BASE_URL

export const axiosInfrakitIAMInstance = axios.create({
  baseURL: REACT_APP_INFRAKIT_IAM_BASE_URL,
});
export const axiosConnectorInstance = axios.create({
  baseURL: REACT_APP_CONNECTOR_BASE_URL,
});

export default function App() {
  axiosConnectorInstance.interceptors.request.use(
    //@ts-ignore
    (config) => {
      let authToken = localStorage.getItem("infrakitToken");
      const token = JSON.parse(authToken || "{}").accessToken;
      return checkToken(config, token as string, () => {
        config.headers!.Authorization = `Bearer ${token}`;
        return config;
      });
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  useEffect(() => {

    axiosConnectorInstance.interceptors.response.use(
      (data) => data,
      axiosErrorHandler
    );
  
  }, []);

  return (
    <div className="App">
      <Router>
        <Routes>
          <Route path="/" element={<InfrakitLogin />} />
          <Route path="/infrakit/projects" element={<InfrakitProjects />} />
          <Route path="/connections" element={<Connections />} />
          <Route path="/trimble/login" element={<TCLogin />} />
          <Route path="/trimble/projects" element={<TrimbleProjects />} />
          <Route path="/folders" element={<Folder />} />
          <Route
            path="/trimble/oauth2redirect"
            element={<RedirectPage />}
          />
        </Routes>
      </Router>
    </div>
  );
}
